import { observer } from "mobx-react-lite";
import style from "./index.module.css";
import { RowEnd, RowStart } from "../Flex/Row";
import { Button, Dropdown, Spin } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { Menu, Space } from "antd";
import { logout } from "@/auth";
import { go } from "@/utils";
import { gstate } from "@/gstate";

export const Layout = observer(({ children }) => {
  const [defOpen, defSelect] = setDefaultKeys();
  return (
    <>
      <div className={style.container}>
        <RowStart className={style.header}>
          <Space className={style.bgDark}>
            <h3>次芽运营后台</h3>
          </Space>
          <RowEnd className={style.bgDark}>
            <Space>
              <Dropdown
                menu={{
                  items: [{ key: "1", label: "退出登录", onClick: logout }],
                }}
              >
                <Button
                  type="link"
                  icon={<UserOutlined color="#fff" />}
                  style={{ padding: 0, color: "#fff" }}
                >
                  {gstate.user.nickname}
                </Button>
              </Dropdown>
            </Space>
          </RowEnd>
        </RowStart>
        <RowStart className={style.content}>
          <div>
            <Menu
              mode="inline"
              style={{ width: 260 }}
              items={gstate.menus}
              defaultSelectedKeys={defSelect}
              defaultOpenKeys={defOpen}
              onSelect={(result) => {
                go(result.key);
              }}
            />
          </div>
          <main>{children}</main>
        </RowStart>
      </div>
      <Spin fullscreen spinning={gstate.loading} tip={gstate.loadingTip} />
    </>
  );
});

const setDefaultKeys = () => {
  const def = [["home"], ["home"]];
  const url = new URL(window.location.href);
  if (url.pathname === "" || url.pathname === "/") {
    return def;
  }
  return [
    [url.pathname.substring(1, url.pathname.lastIndexOf("/"))],
    [url.pathname.substring(1)],
  ];
};
